import { useIntl } from 'react-intl';
import styled from 'styled-components';

import type { InteractionTrackingEvent } from '@xing-com/crate-communication-tracking';
import { useTracking } from '@xing-com/crate-communication-tracking';
import { useJobsNwtTracking } from '@xing-com/crate-jobs-tracking';
import {
  SingleSizeIllustrationFeedbackActiveSad,
  SingleSizeIllustrationFeedbackActiveNeutral,
  SingleSizeIllustrationFeedbackActiveVeryHappy,
} from '@xing-com/illustrations';

import { ColorFeedback } from './color-feedback';
import type { FeedbackVariant } from './color-feedback';

type Props = {
  trackingToken?: string;
  onClick: (feedback: FeedbackVariant) => void;
};

type TrackingProps = {
  PropTrackAction: string;
};

export const FeedbackContent: React.FC<Props> = ({
  trackingToken,
  onClick,
}) => {
  const { formatMessage } = useIntl();
  const { track: trackAdobeEvent } =
    useTracking<InteractionTrackingEvent<TrackingProps>>();
  const trackNwtEvent = useJobsNwtTracking();

  const handleOnClick = (feedback: FeedbackVariant): void => {
    trackAdobeEvent({
      type: 'interaction',
      event: 'PropTrackAction',
      PropTrackAction: `jobs_search_ai_search_results_feedback_${feedback}`,
    });
    trackNwtEvent({
      eventSchema: 'aicomponent',
      page: 'jobs_search/serp',
      event: 'feedback_sent',
      feedback,
      feedbackQuestion: formatMessage({
        id: 'JOBS_SEARCH_AI_FEEDBACK_HEADLINE_V2',
      })
        .toLowerCase()
        .replace(/ /g, '_'),
      element: 'icon',
      componentName: 'ai_search',
      componentFeedbackLevel: '2',
      trackingToken,
    });

    onClick(feedback);
  };

  return (
    <IconsContainer>
      <ColorFeedback
        Illustration={SingleSizeIllustrationFeedbackActiveSad}
        variant="dislike"
        onClick={handleOnClick}
      />
      <ColorFeedback
        Illustration={SingleSizeIllustrationFeedbackActiveNeutral}
        variant="neutral"
        onClick={handleOnClick}
      />
      <ColorFeedback
        Illustration={SingleSizeIllustrationFeedbackActiveVeryHappy}
        variant="like"
        onClick={handleOnClick}
      />
    </IconsContainer>
  );
};

const IconsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 100%;
`;
